import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { PiCaretDown } from "react-icons/pi";
export function Accordion({ icon: Icon, children, title, className, ...rest }) {
    return (_jsxs("details", { className: classNames("cvr-accordion", className), ...rest, children: [_jsxs("summary", { children: [Icon, title, _jsx("span", { className: "cvr-accordion-marker", children: _jsx(PiCaretDown, {}) })] }), _jsx("div", { className: "cvr-accordion-details", children: children })] }));
}
